module.exports = __webpack_public_path__ + "static/img/watting.f22c9ea3.png";